import * as React from 'react';
import classNames from 'classnames';
import { Row, Col } from '../grid';
function getGrid(grid, t) {
    return grid && grid[t] && Math.floor(24 / grid[t]);
}
const Grid = (props) => {
    const renderContent = () => {
        const { column, prefixCls } = props;
        if (column) {
            let col = column;
            const cols = [];
            while (col && col > 0) {
                cols.push(React.createElement(Col, { span: getGrid(props, 'column'), xs: getGrid(props, 'xs'), sm: getGrid(props, 'sm'), md: getGrid(props, 'md'), lg: getGrid(props, 'lg'), xl: getGrid(props, 'xl'), xxl: getGrid(props, 'xxl') },
                    React.createElement("div", { className: `${prefixCls}-content` })));
                col--;
            }
            return cols;
        }
        return React.createElement(Col, null,
            React.createElement("div", { className: `${prefixCls}-content` }));
    };
    const { prefixCls, className, style, rows, gutter } = props;
    const rowList = (React.createElement(Row, { gutter: gutter }, [...Array(rows)].map(() => renderContent())));
    return (React.createElement("div", { className: classNames(prefixCls, className), style: style }, rowList));
};
export default Grid;
